// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const ZeroOffsets = ({ size, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 48 48'
      width={size}
      height={size}
      fill='none'
      strokeWidth='2px'
      stroke={stroke}
    >
      <path d='M2.03,19.74C3.45,10.66,12.28,1.6,24,1.59c9.01,0,16.56,4.94,20.46,12.9' />
      <polygon points='38.66 10.87 39.33 10.12 44.2 14.51 43.29 8.02 44.28 7.88 45.57 17.09 38.66 10.87' />
      <path d='M46.03,28.26c-1.42,9.07-10.25,18.14-21.96,18.15-9.01,0-16.56-4.94-20.46-12.9' />
      <polygon points='9.41 37.13 8.74 37.88 3.87 33.49 4.78 39.98 3.79 40.12 2.5 30.91 9.41 37.13' />
      <path d='M24,15c4.96,0,9,4.04,9,9s-4.04,9-9,9-9-4.04-9-9,4.04-9,9-9M24,14c-5.52,0-10,4.48-10,10s4.48,10,10,10,10-4.48,10-10-4.48-10-10-10h0Z' />
      <line x1='24' y1='37' x2='24' y2='11' />
    </svg>
  );
};
